export const thaiBath = (val,hasIcon = true,isShort = false) => {
  var value = val;
  if(value === "0" || !value){
    if(hasIcon){
      return "฿0"
    }
    return "0"
  }
  var newvalue = 0;
  if(isShort){
    newvalue = value/1000;
    if(newvalue >= 1000){
      var conv_spt_ar = (""+(newvalue/1000)).split(".")
      if(conv_spt_ar.length > 1){
        conv_spt_ar[1] = conv_spt_ar[1].substr(0,2) // decimal point 
        
        if(conv_spt_ar[1] < 10 && conv_spt_ar[1] != 0){
          conv_spt_ar[1] += "0"
        }

        conv_spt_ar[0] = convertFormatMoney(parseInt(conv_spt_ar[0]))
        newvalue = conv_spt_ar.join(".") + "M";
      }else{
        newvalue = conv_spt_ar + "M";
      }
    }else{
      var conv_spt_ar = (""+newvalue).split(".")
      if(conv_spt_ar.length > 1){
        conv_spt_ar[1] = conv_spt_ar[1].substr(0,1) // decimal point 
        // if(conv_spt_ar[1] < 10 && conv_spt_ar[1] != 0){
        //   conv_spt_ar[1] += "0"
        // }
        // newvalue =  conv_spt_ar.join(".")+"K"
        newvalue =  conv_spt_ar.join(".")+"K"
      }else{
        newvalue = conv_spt_ar + "K";
      }
    }
    return ((hasIcon)? "฿":"") + newvalue;
  }else{
    var re = convertFormatMoney(val)
    return ((hasIcon)? "฿":"") + re;
  }
  
}
function convertFormatMoney(num){
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const toPercent = (val,max)=>{
  const per = Math.floor(val/(max/100));
  if(!per){
    return 0;
  }else if(val > max){
    return 100;
  }
  return per;
}